import React, {createContext, useContext, useEffect, useState} from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../../Context/ZooPassAnswersContext";
import {StepTitleContent} from "../PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "../PanelContents/ImageAnswer";
import ZooPassLocalStateUtility from "../../Utilities/ZooPassLocalStateUtility";

export const Step3SidebarValue : React.FC = () => {

    let {
        numericValues,
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading,
        updateContext
    } = useZooPassAppAnswersContext();
    
    if(!answersLoading && !loading && numericValues !== null && answersData !== null)
    {
        const valueFormat = numericValues.get("ZooPass:ProgressValue:03:Adults");
        if(valueFormat != null){
            if(answersData.step3Value === 1){
                return(<><span>{valueFormat.format1}</span></>);
            }
            if(answersData.step3Value === 2){
                return(<><span>{valueFormat.formatN}</span></>);
            }
        }
    }
    
    return(<><span>&nbsp;</span></>);
};

